module.exports = __webpack_public_path__ + "img/case_01_2.fb026a1c.png";